import { useEffect, useState } from "react";
import { TopBar } from "../components/TopBar";
import { TabBar } from "../components/TabBar";
import { api } from "../api/client";
import type { ProgressSummary, WorkoutSession } from "../api/types";

export const Progress = () => {
  const [summary, setSummary] = useState<ProgressSummary | null>(null);
  const [sessions, setSessions] = useState<WorkoutSession[]>([]);

  useEffect(() => {
    Promise.all([
      api<ProgressSummary>("/progress/summary"),
      api<WorkoutSession[]>("/sessions"),
    ]).then(([s, ss]) => {
      setSummary(s);
      setSessions(ss);
    });
  }, []);

  // Weekly workout count over the last 12 weeks
  const buckets = (() => {
    const out: { label: string; count: number }[] = [];
    const now = new Date();
    for (let i = 11; i >= 0; i--) {
      const end = new Date(now);
      end.setUTCDate(end.getUTCDate() - i * 7);
      const start = new Date(end);
      start.setUTCDate(end.getUTCDate() - 6);
      const startStr = start.toISOString().slice(0, 10);
      const endStr = end.toISOString().slice(0, 10);
      out.push({
        label: `${start.getUTCMonth() + 1}/${start.getUTCDate()}`,
        count: sessions.filter(
          (s) => s.status === "completed" && s.date >= startStr && s.date <= endStr,
        ).length,
      });
    }
    return out;
  })();

  const max = Math.max(...buckets.map((b) => b.count), 1);

  return (
    <>
      <div className="page">
        <TopBar title="Progress" back />

        <div className="summary-grid">
          <div className="card">
            <div className="muted">This week</div>
            <div className="big">{summary?.thisWeek ?? "–"}</div>
          </div>
          <div className="card">
            <div className="muted">Streak</div>
            <div className="big">{summary?.streak ?? "–"}</div>
          </div>
          <div className="card">
            <div className="muted">Total</div>
            <div className="big">{summary?.totalSessions ?? "–"}</div>
          </div>
          <div className="card">
            <div className="muted">Volume</div>
            <div className="big">
              {summary ? Math.round(summary.totalVolume / 1000) + "k" : "–"}
            </div>
          </div>
        </div>

        <h2 className="h2">Workouts per week</h2>
        <div className="card">
          <div className="bar-chart">
            {buckets.map((b, i) => (
              <div
                key={i}
                className={`bar ${b.count === 0 ? "lite" : ""}`}
                style={{ height: `${(b.count / max) * 100}%` }}
                title={`${b.label}: ${b.count}`}
              />
            ))}
          </div>
          <div className="row" style={{ marginTop: 8, fontSize: 11, color: "var(--ink-dim)" }}>
            <span>{buckets[0]?.label}</span>
            <div className="spacer" />
            <span>{buckets[buckets.length - 1]?.label}</span>
          </div>
        </div>
      </div>
      <TabBar />
    </>
  );
};
